import { useState } from 'react';
import { Wallet, Plus, Landmark, Repeat, NotebookPen, FilePenLine, BriefcaseBusiness, Calculator, ChartNoAxesCombined, Lightbulb, FileChartColumn, Archive } from 'lucide-react';
import SalaryPanel from './SalaryPanel';
import TaxPanel from './TaxPanel';
import Budgets from './Budgets';
import AiTips from './AiTips';
import MonthlyReport from './MonthlyReport';
import Backup from './Backup';
import { t } from '@/lib/i18n';

const tools = [
  { id:'salary', label:'Salary planning', icon:BriefcaseBusiness, component:SalaryPanel },
  { id:'tax', label:'Tax estimate', icon:Calculator, component:TaxPanel },
  { id:'budget', label:'Budget', icon:ChartNoAxesCombined, component:Budgets },
  { id:'tips', label:'Smart money tips', icon:Lightbulb, component:AiTips },
  { id:'report', label:'Monthly report', icon:FileChartColumn, component:MonthlyReport },
  { id:'backup', label:'Backup & restore', icon:Archive, component:Backup },
];

const TILE = 'mm-card !p-2 sm:!p-3 flex aspect-[1.55/1] min-h-[94px] w-full min-w-0 flex-col items-center justify-center gap-2 text-center transition-transform hover:-translate-y-0.5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-[var(--ac)]';

export default function ToolButtons({ onIncome, onExpense, onSavings, onRecurring, onNotepad, onPdfEditor }) {
  const [active, setActive] = useState(null);
  const selected = tools.find(tool => tool.id === active);
  const Panel = selected?.component;
  const shortcuts = [
    { id:'income', label:'Income', icon:Wallet, action:onIncome, testId:'quick-action-add-income-button' },
    { id:'expense', label:'Expense', icon:Plus, action:onExpense, testId:'quick-action-add-expense-button' },
    { id:'savings', label:'Savings', icon:Landmark, action:onSavings, testId:'quick-action-savings-button' },
    { id:'recurring', label:'Recurring', icon:Repeat, action:onRecurring, testId:'quick-action-recurring-button' },
    { id:'notepad', label:'Notepad', icon:NotebookPen, action:onNotepad, testId:'quick-action-notepad-button' },
    { id:'pdf-editor', label:'PDF Editor', icon:FilePenLine, action:onPdfEditor, testId:'quick-action-pdf-editor-button' },
  ];
  return <section aria-label="BudgetPulse actions and money tools" data-testid="money-tool-buttons" className="space-y-3">
    <div className="grid grid-cols-4 gap-2" aria-label="Quick actions and money tools">
      {shortcuts.map(({ id, label, icon:Icon, action, testId }) => <button key={id} type="button" onClick={action} className={TILE} data-testid={testId}>
        <Icon className="h-6 w-6 shrink-0 text-[var(--ac)]" aria-hidden="true" />
        <span className="text-xs font-semibold leading-tight sm:text-sm">{t(label)}</span>
      </button>)}
      {tools.map(({ id, label, icon:Icon }) => <button key={id} type="button" data-testid={`tool-button-${id}`}
        aria-expanded={active === id} aria-controls={active === id ? 'money-tool-panel' : undefined}
        onClick={() => setActive(active === id ? null : id)}
        className={`${TILE} ${active === id ? '!border-[var(--ac)]' : ''}`}>
        <Icon className="h-6 w-6 shrink-0 text-[var(--ac)]" aria-hidden="true" />
        <span className="text-xs font-semibold leading-tight sm:text-sm">{t(label)}</span>
      </button>)}
    </div>
    {Panel && <div id="money-tool-panel" role="region" aria-label={t(selected.label)} data-testid="expanded-money-tool"><Panel /></div>}
  </section>;
}
